import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Actions
import {
  clearBuyersList,
  getBuyersList,
} from "../../../actions/buyer/BuyerActions";

// Constants and Utils
import { LocalStorageKeys } from "../../../constants/GeneralConstants";
import { getItem } from "../../../utils/localstorage";

function ErrorMessage({ error }) {
  if (!error) {
    return null;
  }

  return (
    <div id="validationServer03Feedback" className="invalid-feedback">
      {error}
    </div>
  );
}

// Admin User Section
function AdminUserSection({ userInfo = {}, formikValuesAndFn }) {
  const { id } = userInfo || {};

  const { values, setFieldValue = () => {} } = formikValuesAndFn || {};
  const { isAdminUser = false } = values || {};

  // LoggedIn User
  const user = JSON.parse(getItem(LocalStorageKeys.USER));
  const { userId } = user || {};

  // checking is manage loggedIn user
  const isManageLoggedInUser = userId === id;

  // data
  const inputsData = [
    {
      id: "adminUser_true",
      checked: isAdminUser,
      label: "Yes",
      onChange: () => setFieldValue("isAdminUser", true),
    },
    {
      id: "adminUser_false",
      checked: !isAdminUser,
      label: "No",
      onChange: () => setFieldValue("isAdminUser", false),
    },
  ];

  return (
    <div className="form-group row">
      <label className="col-sm-2 col-form-label">Admin User</label>
      <div className="col-sm-10 mt-2">
        {inputsData.map((data, i) => {
          const { id, checked, onChange, label } = data;
          return (
            <Fragment key={i}>
              <input
                type="radio"
                id={id}
                name="isAdminUser"
                checked={checked}
                onChange={onChange}
                disabled={isManageLoggedInUser}
              />
              <label className="m-0 pl-2 mr-5" htmlFor={id}>
                {label}
              </label>
            </Fragment>
          );
        })}

        {/* warning text */}
        {isManageLoggedInUser && (
          <span className="font-italic text-warning">
            <i className="fa fa-exclamation-triangle mr-2" />
            Changing Self Role Is Disabled
          </span>
        )}
      </div>
    </div>
  );
}

// Buyer Section
function BuyerSection({ inputClassName = "", formik = {}, user = {} }) {
  const dispatch = useDispatch();

  // state
  const [buyerName, setBuyerName] = useState("");
  const [selectedBuyer, setSelectedBuyer] = useState({});

  // Selector
  const buyersList = useSelector((state) => state.buyer.buyersList);

  // user data
  const { buyerId, buyerName: usersBuyerName } = user || {};

  // update case
  useEffect(() => {
    if (buyerId) {
      setSelectedBuyer({
        id: buyerId,
        name: usersBuyerName,
      });
    }
  }, [JSON.stringify(user)]);

  useEffect(() => {
    dispatch(clearBuyersList());
  }, [dispatch]);

  // update formik values
  useEffect(() => {
    const { id, name } = selectedBuyer || {};
    formik.setFieldValue("buyerId", id);
    formik.setFieldValue("buyerName", name);
  }, [JSON.stringify(selectedBuyer)]);

  // Search buyer From Input Function
  function searchBrandFn({ target }) {
    const inputText = target.value;
    setBuyerName(inputText);

    if (inputText.length <= 1) {
      dispatch(clearBuyersList());
      return;
    }

    // search buyers
    dispatch(clearBuyersList());
    dispatch(getBuyersList(inputText));
  }

  // handle select brand
  function handleBrandSelect(buyer) {
    setSelectedBuyer(buyer);
    dispatch(clearBuyersList());
  }

  // clear
  function handleRemoveBrand() {
    setSelectedBuyer({});
    setBuyerName("");
    dispatch(clearBuyersList());
  }

  // checking is buyer selected
  const isBuyerSelected = Object.keys(selectedBuyer).length > 0;

  return (
    <div className="form-group row">
      <label className="col-sm-2 col-form-label">Brand</label>
      <div className="col-sm-10">
        {/* buyer remove btn */}
        {isBuyerSelected && (
          <div className="d-flex align-items-center mt-1">
            <span>{selectedBuyer.name}</span>
            <button
              className="btn btn-sm btn-danger ml-4"
              onClick={handleRemoveBrand}
            >
              Remove
            </button>
          </div>
        )}

        {/* search input */}
        {!isBuyerSelected && (
          <>
            <input
              className={inputClassName}
              placeholder="Search Brand"
              value={buyerName}
              onChange={searchBrandFn}
            />

            {/* Suggested Buyer*/}
            {buyersList.length > 0 && (
              <div className="border rounded-lg mt-1 bg-alt">
                {buyersList.map((eachBuyer, i) => (
                  <li
                    key={i}
                    className="dropdown-item cursor-pointer"
                    onClick={() => handleBrandSelect(eachBuyer)}
                  >
                    {eachBuyer.name}
                  </li>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export { ErrorMessage, AdminUserSection, BuyerSection };
